import { consumePantryItemRequestSchema, consumePantryItemResponseSchema, createPantryItemRequestSchema, pantryExpiringResponseSchema, pantryItemDtoSchema, pantryListResponseSchema, updatePantryItemRequestSchema, } from '@fewerbags/schema';
const item = { parse: pantryItemDtoSchema };
/** /api/v1/pantry — the signed-in household's pantry inventory. */
export function createPantryApi(http, base) {
    return {
        /** Grouped by location (pantry, fridge, freezer); each group ordered by soonest expiry. */
        list: async (query = {}) => http.get(base, {
            query: {
                location: query.location,
                expiringWithinDays: query.expiringWithinDays,
                q: query.q,
            },
            parse: pantryListResponseSchema,
        }),
        /** Items expiring within `days` (default 3), soonest first. */
        expiring: async (days = 3) => http.get(`${base}/expiring`, { query: { days }, parse: pantryExpiringResponseSchema }),
        get: async (id) => http.get(`${base}/${id}`, item),
        /** ingredientId or name (exactly one); expiresOn omitted is estimated from shelf life. */
        create: async (input) => http.post(base, createPantryItemRequestSchema.parse(input), item),
        update: async (id, input) => http.patch(`${base}/${id}`, updatePantryItemRequestSchema.parse(input), item),
        remove: async (id) => http.del(`${base}/${id}`),
        /** Reduces qty (converted to the item's unit); the item is removed once it reaches zero. */
        consume: async (id, input) => http.post(`${base}/${id}/consume`, consumePantryItemRequestSchema.parse(input), {
            parse: consumePantryItemResponseSchema,
        }),
    };
}
//# sourceMappingURL=pantry.js.map